import SecureDataflowService from "@/services/secureDataflowService";

export default {

  async setIsDisplayOtherVessels({ commit, state }, val) {
    const obj = {
      ...state,
      isDisplayOtherVessels: val,
    };
    SecureDataflowService.saveSettings(obj);
    commit("SET_IS_DISPLAY_OTHER_VESSELS", val);
  },

  async setOnAlertSummaryNotification({ commit, state }, val) {
    const obj = {
      ...state,
      onAlertSummaryNotification: val,
    };
    SecureDataflowService.saveSettings(obj);
    commit("SET_ON_ALERT_SUMMARY_NOTIFICATION", val);
  },

  async setVesselAutoTracking({ commit, state }, val) {
    const obj = {
      ...state,
      onVesselAutoTracking: val,
    };
    SecureDataflowService.saveSettings(obj);
    commit("SET_ON_VESSEL_AUTO_TRACKING", val);
  },

  async setTrackDisplayInterval({ commit, state }, val) {
    const obj = {
      ...state,
      trackDisplayInterval: val,
    };
    SecureDataflowService.saveSettings(obj);
    commit("SET_TRACK_DISPLAY_INTERVAL", val);
  },

  async setTrackHistoryInterval({ commit, state }, val) {
    const obj = {
      ...state,
      trackHistoryInterval: val,
    };
    SecureDataflowService.saveSettings(obj);
    commit("SET_TRACK_HISTORY_INTERVAL", val);
  },

  resetSdfMenuState({ commit }) {
    let defaultState = {
      isDisplayOtherVessels: true,
      onAlertSummaryNotification: true,
      onVesselAutoTracking: false,
      trackDisplayInterval: 60,
      trackHistoryInterval: 60,
    };
    commit("RESET_STATE", defaultState);
  },

  async setSdfMenuSettings({ commit, state }) {
    const settings = await SecureDataflowService.getSettings();
    const nextSettings = {
      ...state,
      isDisplayOtherVessels: settings.is_display_other_vessels,
      onAlertSummaryNotification: settings.on_alert_summary_notification,
      onVesselAutoTracking: settings.on_vessel_auto_tracking,
      trackDisplayInterval: settings.track_display_interval,
      trackHistoryInterval: settings.track_history_interval,
    };
    commit("SET_SETTINGS", nextSettings);
  }
};
